import Add from '@mui/icons-material/Add'
import { Button } from '@mui/material'
import useOverlay from '@/hooks/useOverlay'
import { useGetProjectTags } from '@/service-library/hooks/project-tags'
import SettingsPage from '@/components/shared/settings/SettingsPage'
import ProjectBreadcrumb from '../project-tables/ProjectBreadcrumb'
import { useProjectContext } from '../project-tables/ProjectProvider'
import AddEditTagDialog from './AddEditTagDialog'
import TagsList from './TagsList'

export default function TagsPage() {
  const { project } = useProjectContext()
  const newTagOverlay = useOverlay()
  const { projectTags, queryKey } = useGetProjectTags({
    filters: {
      limit: '1000',
      project_id: project.id,
    },
  })

  return (
    <>
      <ProjectBreadcrumb label="Document Tags" url="../tags" />

      <SettingsPage
        title="Document Tags"
        description="Tags that can be applied to documents for categorization, workflow actions, and sorting."
        width="sm"
        actions={
          <Button
            variant="text"
            startIcon={<Add />}
            onClick={newTagOverlay.open}
          >
            New tag
          </Button>
        }
      >
        <TagsList projectTags={projectTags} listQueryKey={queryKey} />
      </SettingsPage>

      <AddEditTagDialog overlay={newTagOverlay} listQueryKey={queryKey} />
    </>
  )
}
